import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { reIdSelectors } from "./store/selectors";
import { reIdActions } from "./store/slice";
import { luxonUtils } from "utils/luxonUtils";

export function PersistedRecordingsList() {
    const dispatch = useAppDispatch();

    const vectorSearchResults = useAppSelector(
        reIdSelectors.selectVectorSearchResults,
    );

    const activeVectorSearchResult = useAppSelector(
        reIdSelectors.selectActiveVectorSearchResultRecordToPlay,
    );

    return (
        <List disablePadding>
            {vectorSearchResults.map((vectorSearchResultRecord) => {
                const isSelected =
                    activeVectorSearchResult?.persistedRecordingId ===
                        vectorSearchResultRecord.persistedRecordingId &&
                    activeVectorSearchResult?.trackerId ===
                        vectorSearchResultRecord.trackerId;

                return (
                    <ListItem
                        key={
                            vectorSearchResultRecord.persistedRecordingId +
                            vectorSearchResultRecord.trackerId
                        }
                        disablePadding
                    >
                        <ListItemButton
                            selected={isSelected}
                            onClick={() => {
                                dispatch(
                                    reIdActions.setActiveVectorSearchResultRecordToPlay(
                                        vectorSearchResultRecord,
                                    ),
                                );
                            }}
                        >
                            <ListItemText
                                id={`switch-list-label-${vectorSearchResultRecord.persistedRecordingId + vectorSearchResultRecord.trackerId}`}
                                primary={`${luxonUtils.fromIso(vectorSearchResultRecord.persistedStartTimeWithFirstSeenTime)?.toFormat("HH:mm:ss")} - ${vectorSearchResultRecord.dossierDeviceName}`}
                                slotProps={{
                                    primary: {
                                        sx: {
                                            fontWeight: isSelected
                                                ? "bold"
                                                : "normal",
                                        },
                                    },
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>
    );
}
